import * as React from "react";
import styled from "styled-components";
import { Glyphicon } from "react-bootstrap";
import { IUserItem } from "@nkr/models/index";

const NameWrapper = styled.div`
    :hover {
        text-decoration: underline;
        cursor: pointer;
    }
`;

interface IProps {
    item: IUserItem,
    backgroundColor: string,
    onSelect: (item: IUserItem) => void,
    onSelectPrimary: (item: IUserItem) => void
}

class GroupUsersListItem extends React.Component<IProps, {}> {
    handleSelect = () => {
        this.props.onSelect(this.props.item);
    }

    handleSelectPrimary = () => {
        this.props.onSelectPrimary(this.props.item);
    }

    render = () => {
        return (
            <>
                <div style={{ display: "flex", alignItems: "center", padding: 5, marginRight: 5, marginBottom: 5, color: "darkblue", backgroundColor: this.props.backgroundColor, borderRadius: 4 }}>
                    <div style={{ marginRight: 5 }}>
                        <Glyphicon glyph={this.props.item.selected ? "check" : "unchecked"} onClick={this.handleSelect} />
                    </div>
                    <NameWrapper onClick={this.handleSelect}>{this.props.item.user.lastName}, {this.props.item.user.firstName}</NameWrapper>
                    {this.props.item.isAssigned && (
                        <div style={{ marginLeft: 5, color: this.props.item.isPrimary ? "red" : "white" }} onClick={this.handleSelectPrimary}><Glyphicon glyph="star" /></div>
                    )}
                </div>
            </>
        )
    }
}

export default GroupUsersListItem;